/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import { defineComponent } from 'vue';

// @ts-ignore Není to ESM.
import template from './clock-root.html';

import { mixinType } from '../../util.type';
import Numeric from '../numeric/numeric';

export default defineComponent({
  name: 'ClockRoot',
  template,
  created() {
    this.interval = setInterval(this.refresh, this.delay);
    this.refresh();
  },
  data() {
    return mixinType(
      {
        /** @type {string | null} */
        value: null
      },
      /**
       * @type {{
       *   interval: ReturnType<typeof setInterval> | undefined;
       * }}
       */
      ({})
    );
  },
  destroyed() {
    clearInterval(this.interval);
  },
  emits: {},
  methods: {
    refresh() {
      const now = new Date();
      const hours = String(now.getHours());
      const minutes = Numeric.toStringPadded(now.getMinutes(), 2);
      this.value = `${hours}:${minutes}`;
    }
  },
  props: {
    delay: { type: Number, required: true }
  }
});
